import camelCase from 'lodash/camelCase';

export default function(obj) {
  if (typeof obj === 'object') {
    return Object.keys(obj).reduce((normalizedKeys, key) => {
      return { ...normalizedKeys, ...{ [camelCase(key)]: obj[key] } }
    }, {});
  }
}
